import React from "react";
import videobg from "../videos/home.mp4";

const Home = ({ classicHeader, darkTheme, handleNavClick }) => {
  return (
    <section id="home">
      <div className="hero-wrap">
        <div className="hero-mask opacity-8 bg-dark" />

        {/* ---------------image background------------------ */}
        {/* <div
          className="hero-bg parallax"
          style={{ backgroundImage: 'url("images/intro-bg.jpg")' }}
        ></div> */}

        {/* -------------------video background---------------------- */}

        <div className="player hero-bg parallax">
          <video
            src={videobg}
            autoPlay
            muted
            loop
            style={{ width: "100%", height: "100vh", objectFit: "cover" }}
          ></video>
        </div>

        <div className="hero-content section d-flex min-vh-100">
          <div className="container my-auto">
            <div className="row justify-content-center">
              <div className="col-12 col-lg-10 col-xl-8">
                <div className="d-flex">
                  <h1
                    className="text-8 fw-400 text-white"
                    style={{ lineHeight: "1.3" }}
                  >
                    Hi, I'm
                  </h1>
                  <h1
                    className="text-8 fw-400 text-primary"
                    style={{ lineHeight: "1.3", marginLeft: ".5rem" }}
                  >
                    Alkin
                  </h1>
                  <h1
                    className="text-8 fw-400 text-white"
                    style={{ lineHeight: "1.3" }}
                  >
                    .
                  </h1>
                </div>
                <h2
                  className="text-12 fw-700 text-white mb-5"
                  style={{ lineHeight: "1.2" }}
                >
                  A Software Engineer
                  <br />
                  based in Hamburg, Germany.
                </h2>
              </div>
            </div>
          </div>
          <a
            href="#about"
            className="scroll-down-arrow text-white smooth-scroll"
            onClick={(e) => {
              e.preventDefault();
              handleNavClick("about");
            }}
          >
            <span className="animated">
              <i className="fa fa-chevron-down" />
            </span>
          </a>
        </div>
      </div>
    </section>
  );
};

export default Home;
